import { Grid } from "antd";

import { Text } from "@/components/Typography";

import { useAppBreadcrumbStore } from "../../AppBreadcrumb.store";

const { useBreakpoint } = Grid;

function SensorDetailBreadcrumb() {
  const { xs } = useBreakpoint();

  const { label } = useAppBreadcrumbStore();

  return (
    <Text
      ellipsis
      style={{
        width: xs ? "150px" : undefined,
      }}
    >
      {label}
    </Text>
  );
}

export default SensorDetailBreadcrumb;
